"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _SwipeableDrawer = _interopRequireDefault(require("@material-ui/core/SwipeableDrawer"));

var _Icon = _interopRequireDefault(require("../../Icon"));

var _Burger = _interopRequireDefault(require("../../Icons/Burger"));

var _MobileHeader = _interopRequireDefault(require("../../MobileHeader"));

var _TouchableOpacity = _interopRequireDefault(require("../../TouchableOpacity"));

var _Links = _interopRequireDefault(require("./Links"));

var _useTheme2 = _interopRequireDefault(require("../../styles/useTheme"));

var _useTranslation = _interopRequireDefault(require("../TranslationProvider/useTranslation"));

var _HomeLink = _interopRequireDefault(require("./HomeLink"));

var _useIsIos = _interopRequireDefault(require("./useIsIos"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  var _useTheme = (0, _useTheme2.default)(),
      spacing = _useTheme.spacing;

  return {
    links: {
      zIndex: 1
    },
    header: {
      zIndex: -1,
      margin: spacing(-8, 0, 0)
    },
    paper: {
      backgroundColor: 'transparent',
      boxShadow: 'unset'
    },
    backdrop: {
      backgroundColor: 'rgba(0,21,41,0.65)'
    }
  };
};

__signature__(useStyles, "useTheme{{ spacing }}", function () {
  return [_useTheme2.default];
});

var Menu = function Menu(props) {
  var _props$LogoProps = props.LogoProps,
      LogoProps = _props$LogoProps === void 0 ? {} : _props$LogoProps,
      children = props.children;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var classes = useStyles();
  var t = (0, _useTranslation.default)();
  var iOS = (0, _useIsIos.default)();
  var handleOnOpen = (0, _react.useCallback)(function () {
    return setOpen(true);
  }, []);
  var handleOnClose = (0, _react.useCallback)(function () {
    return setOpen(false);
  }, []);
  return (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)(_TouchableOpacity.default, {
    "data-testid": "BurgerMenu",
    "aria-label": open ? t('close_menu') : t('open_menu'),
    onClick: handleOnOpen
  }, (0, _core.jsx)(_Icon.default, {
    as: _Burger.default,
    color: "primary",
    size: 8
  })), (0, _core.jsx)(_styles.StylesProvider, {
    injectFirst: true
  }, (0, _core.jsx)(_SwipeableDrawer.default, {
    anchor: "top",
    open: open,
    disableBackdropTransition: !iOS,
    onOpen: handleOnOpen,
    onClose: handleOnClose,
    PaperProps: {
      style: classes.paper
    },
    BackdropProps: {
      style: classes.backdrop
    }
  }, (0, _core.jsx)(_Links.default, null, (0, _core.jsx)(_HomeLink.default, LogoProps), children), (0, _core.jsx)(_MobileHeader.default, {
    css: classes.header
  }, (0, _core.jsx)("span", null)))));
};

__signature__(Menu, "useState{[open, setOpen](false)}\nuseStyles{classes}\nuseTranslation{t}\nuseIsIos{iOS}\nuseCallback{handleOnOpen}\nuseCallback{handleOnClose}", function () {
  return [useStyles, _useTranslation.default, _useIsIos.default];
});

var _default = Menu;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/Mobile/Menu.tsx");
  reactHotLoader.register(Menu, "Menu", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/Mobile/Menu.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/Mobile/Menu.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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